// extracted by mini-css-extract-plugin
module.exports = {"envelope":"styles_envelope__xaEAd","image":"styles_image__1_A7m","notifications":"styles_notifications__3UhxC"};